module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA40lEQVQ4jbWTMQ6CQBBF0U7srGzovAjxBBaew8twBWO5nQkxJBzAI9haWFFgsND4bMa4GXYACybZYt8f/vzdDVE0ZgExUNKu7B+Ts/dhDTggV4a7PpOHNB4MfQpcpcf1JVkPSH2U3o0W4q4khtkTQMOyBX/aSobMFE+Epz4EqDumvwwzgEID5+1vgadHpxbUaJB7+xNwUcsyqjQI3pGvA5MA3/sgEzgNmMwNk63wZWjq1UplpHyHhJ2IxwEmd+ldWA1OGp5AEtC/x4G+PwDYWE//PY6ZxDBMgQJogArYty52jPoAO3HI2S0o7doAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sendgood.png
// module id = urFK
// module chunks = 1